import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Col, Row } from 'react-bootstrap'

import FilterList from 'material-ui/svg-icons/content/filter-list'
import Card from 'material-ui/Card'
import { CardHeader } from 'material-ui/Card'
import { CardText } from 'material-ui/Card'
import Avatar from 'material-ui/Avatar'
import Checkbox from 'material-ui/Checkbox'
import RaisedButton from 'material-ui/RaisedButton'
import { grey400 } from 'material-ui/styles/colors'
import {
  getUserSettings,
} from "../../reducers/integrations/resources";
import Conversations from './conversations'
import Threads from './threads'
import { getBots, getAssignedBots, getUserCompanyBots,getBotsPerCompany, getCompanyTags, getCompanyTagsByCompanyId } from '../../reducers/bots/resources'
import { getAllDepartmentsByCompany, getDepartmentByCompany } from '../../reducers/department/resources';

import {
  changeConvo,
  setConvoDetails,
  filterConvo,
  getAllConvo,
  toggleConvoLoading,
  resetConvos,
  filterConvoList,
} from '../../reducers/inbox/actions'

import mixpanel from '../../utils/mixpanel'
import session from '../../utils/session'
import format from '../../utils/format'
import config from '../../config'
import { initRoom, leaveRoom } from '../../io'

import './index.css'

const ALL_CONTACTS = 'all contacts';
const ALL_NUMBERS = 'all texting numbers';
const ALL_LOCATIONS = 'all locations';
const EXCLUDED_DEFAULT = ['shortcode', 'NULL'];
const BOT_TYPES = {
  webchat: 'Web Chat',
  messagemedia: 'Message Media'
}

class Inbox extends Component {
  componentWillMount() {
    const { 
      companyId,
      username,
      role: userRole,
      name: user,
      isActiveCompany
    } = session.get('userData')
    const isAdmin = userRole === config.userRoles.ghAdmin;
    const selectedCompany = isAdmin ? this.props.selectedCompany : companyId

    this.setState({
      allBots: [],
      companyBots: [],
      isAdmin: isAdmin,
      selectedCompany: selectedCompany,
      userCompany: companyId,
      openFilter: false,
      departmentList: [],
      contactFilter: [],
      tagsList: [],
      groupFilterCheck: {
        all: false,
        bot: false,
        location: false
      },
      // check if user already has isActiveCompany flag (need to re-login) and is it active/not
      isInactiveCompany: isAdmin ? false : (!_.isUndefined(isActiveCompany) && !isActiveCompany)
    })

    if (!isAdmin) {
      this.fetchUserBots()

    } else {
      ;(async () => {
        await this.fetchCompanyBots(selectedCompany || companyId)
      })()
    }

    this.setState({ username, user })
  }

  componentWillUnmount() {
    this.leaveRooms()
  }

  titleCase(input) {
    // Split the input string into an array of words
    var words = input.toLowerCase().split(/\s+/);
    
    // Iterate over each word in the array
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      
      // Capitalize the first letter of each word and concatenate with the rest of the word
      words[i] = word.charAt(0).toUpperCase() + word.slice(1);
    }
    
    // Join the modified words back into a single string
    var titleCaseString = words.join(' ');
    
    return titleCaseString;
  }
  

  componentWillReceiveProps(nextProps) {
    const { selectedCompanyData } = nextProps;
    if (this.state.isAdmin) {
      const selectedCompany = nextProps.selectedCompany || this.state.userCompany
      this.leaveRooms()
      this.setState(
        {
          selectedCompany,
          contactFilter: [],
          groupFilterCheck: {
            all: false,
            bot: false,
            location: false
          },
          isInactiveCompany: false
        },
        async () => {
          await this.fetchCompanyBots(selectedCompany)
        },
      )
      
      if(selectedCompanyData && !selectedCompanyData.active) {
        this.setState({ isInactiveCompany: true })
      }
    }
  }

  leaveRooms = () => {
    this.state.companyBots.map((bot) => leaveRoom(bot.botmap_id))
    this.state.departmentList.map(dept => leaveRoom(dept.id))
    this.state.tagsList.map(tag => leaveRoom(tag.id))
  }

  fetchUserBots = async () => {
    let temp = [];

    let bots = await getUserCompanyBots();
    let tagsRes = await getCompanyTags();
    let deptRes = await getAllDepartmentsByCompany();
    let settings = await getUserSettings();
    settings = settings.data;

    tagsRes = this.constructTagsData(tagsRes);
    temp.push(...tagsRes.temp)
    deptRes = this.constructDepartmentData(deptRes);
    temp.push(...deptRes.temp)

    if (bots && bots.data.length) {
      bots.data.map((bot) => {
        if ((bot.departments || []).length > 1) {
          bot.departments.map((dept) => this.props.initRoom(dept.id))
        }
        this.props.initRoom(bot.botmap_id)

        if(!EXCLUDED_DEFAULT.includes(bot.default)) {
          temp.push({
            name: bot.mobile,
            value: false,
            id: bot.botmap_id,
            type: 'bot',
            company_id: bot.company_id
          })
        }
      })
    }

    if (settings && settings.defaultInboxFilters) {
      let savedFilters = [];
      if (Array.isArray(settings.defaultInboxFilters)) {
        savedFilters = settings.defaultInboxFilters;
      } else if (settings.defaultInboxFilters[this.state.userCompany]) {
        savedFilters = settings.defaultInboxFilters[this.state.userCompany];
      }

      savedFilters.forEach((dif) => {
        let idx = temp.findIndex(
          (elem) => elem.type === dif.type && elem.id === dif.id
        );
        if (idx >= 0) {
          temp[idx].value = true;
        }
      });
    }

    this.setState({
      companyBots: bots.data,
      departmentList: deptRes.departmentList,
      tagsList: tagsRes.data,
      contactFilter: temp
    })
    
    this.onSearchContacts()
    //this.props.filterConvoList(temp)
  }

  constructTagsData = (result) => {
    if(result) {
      const temp = result.data.map(val => {
        return({
          name: val.value,
          value: false,
          id: `${val.value}`,
          type: 'tag',
          company_id: val.company_id
        })
      })

      return {
        data: result.data,
        temp
      }
    }
  }

  constructDepartmentData = (result) => {
    const { isAdmin } = this.state
    if(result) {
      const temp = result.data.map(val => {
        
        // create socket room for locations
        if(!isAdmin) {
          this.props.initRoom(val.id)
        }

        return({
          name: val.name,
          value: false,
          id: val.id,
          type: 'location',
          company_id: val.company_id
        })
      })

      return {
        departmentList: result.data,
        temp
      }
    }
  }

  fetchCompanyBots = async (selectedCompany) => {
    let constructedValues = []
    let flattenedBotData = []

    const companyId = selectedCompany
    let bots  = await getBotsPerCompany(companyId)

    if(bots && bots.data) {
      flattenedBotData = bots.data.map((bot) => {
        return {
          botmap_id: bot.botmap_id,
          default: bot.default,
          id: bot.id,
          mobile: bot.mobile,
          user: bot.user,
          user_id: bot.user_id,
          type: bot.type,
          company_id: bot.company_id
        }
      })
    }

    if(flattenedBotData.length) {
      flattenedBotData.forEach(val => {
        constructedValues.push({
          name: val.mobile,
          value: false,
          id: val.botmap_id,
          type: 'bot',
          user: val.user,
          user_id: val.user_id,
          company_id: val.company_id
        })
      })
    }

    this.setState({ companyBots: flattenedBotData })

    getDepartmentByCompany(companyId)
    .then(result => {
      const res = this.constructDepartmentData(result);
      constructedValues.push(...res.temp)
      this.setState({
        departmentList: res.departmentList,
        contactFilter: constructedValues
      })
      this.props.filterConvoList(constructedValues)
    })
  
    getCompanyTagsByCompanyId(companyId)
    .then(result => {
      const res = this.constructTagsData(result);
      constructedValues.push(...res.temp)
      this.setState({
        tagsList: res.data,
        contactFilter: constructedValues
      })
      this.props.filterConvoList(constructedValues)
    })
  
  }

  constructFilters = (name, val, bot=null) => {
    const { contactFilter, groupFilterCheck } = this.state;
    let newValues = [];
    let groupChecks;

    const mapValues = ( type=null) => {
      return contactFilter.map(filter => {
        let value = type ? (filter.type === type && val) : val

        if(filter.type=='tag'){
          value = false
        }

        return {
          name: filter.name,
          value,
          id: filter.id,
          type: filter.type,
          company_id:filter.company_id
        }
      })
    }

    if(name === ALL_CONTACTS) {
      groupChecks = {
        all: val,
        bot: false,
        location: false
      }

      newValues = mapValues()
    } else if(name === ALL_NUMBERS) {
      groupChecks = {
        all: false,
        bot: val,
        location: false
      }

      newValues = mapValues('bot')
    } else if(name === ALL_LOCATIONS) {
      groupChecks = {
        all: false,
        bot: false,
        location: val
      }

      newValues = mapValues('location')
    } else {
      groupChecks = {
        all: false,
        bot: false,
        location: false
      }

      newValues = contactFilter.map(filter => {
        if(filter.name === name) {
          filter.value = val
        }

        return {
          name: filter.name,
          value: filter.value,
          id: filter.id,
          type: filter.type,
          company_id:filter.company_id
        }
      })

      const filteredBotList = newValues.filter(val => (val.type === 'bot') && !val.value)
      const filteredLocList = newValues.filter(val => (val.type === 'location') && !val.value)
      const filteredList = newValues.filter(val => !val.value)

      if(bot!=null){
        //add-in the other 1-1 bots owned by the same user
        if(['b-longcode','longcode'].includes(bot.default)){
          let otherTextingNumbers = 
           this.state.companyBots.filter((b)=>b.user_id == bot.user_id && ['b-longcode','longcode'].includes(b.default) && b.id!=bot.id) 
         
          otherTextingNumbers.forEach((number)=>{
          
            newValues.forEach((filter)=>{
              if(filter.id===number.botmap_id){
                filter.value=val
              }
            });
          })
         
        }
      }
     
      groupChecks = {
        bot: !filteredBotList.length,
        location: !filteredLocList.length,
        all: !filteredList.length
      }

      // enforce to uncheck bot and location
      // if all filters are checked
      // to give way to all filters check
      if(!filteredList.length) {
        groupChecks = {
          bot: false,
          location: false,
          all: true
        }
      }
    }

    this.setState({
      contactFilter: newValues,
      groupFilterCheck: {...groupFilterCheck, ...groupChecks}
    })
  }

  onSearchContacts = () => {
    if(this.state.contactFilter
      .filter(filter => filter.value).length===0){
      this.constructFilters(ALL_CONTACTS, true)
    }

    const filtered = this.state.contactFilter
    .filter(filter => filter.value)
    .map(filter => {
      const { id, type,company_id } = filter
      return { id, type, company_id }
    });
  
  mixpanel.track(
    'inbox:switch filter',
    { data: filtered }
  );

    this.props.filterConvoList(filtered)
    this.setState({ openFilter: false })
  }

  render() {
    let botFilters = []
    let departments = []
    let tags = []

    if(this.state.companyBots.length) {
      botFilters = this.state.companyBots
        .filter(val => !EXCLUDED_DEFAULT.includes(val.default))
        .map((bot) => {
          let label;
          
          let formatted = format.forceFormat(bot.mobile)
          
          if(bot.mobile.split(' ').length > 1){
            const [number, ...rest] = bot.mobile.split(' ')
            const addedText = rest.join(' ')
            formatted = `${format.forceFormat(number)} ${addedText}`
          }

          const checked = _.find(this.state.contactFilter, { name: bot.mobile})

          switch(bot.default) {
            case null:
              if(['webchat', 'messagemedia'].includes(bot.type)) {
                label = `${BOT_TYPES[bot.type]} - ${formatted}`;
              } else {
                label = `Apply by Text - ${formatted}`;
              }
              break;
            case 'longcode':
            case 'b-longcode':
              label = `${bot.user}`;
            break;
            case 'broadcast':
              label = `Broadcast Texting - ${formatted}`;
              break;
            case 'webchat':
              label = 'Web Chat';
              break;
            case 'messagemedia':
              label = 'Message Media';
              break;
            default:
              break;
          }

          return {
            checked,
            label,
            bot
          }
        })

        botFilters = _.uniqBy(botFilters,(b)=>b.label);
        botFilters = botFilters.sort((a,b)=>{
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        }).map((filter)=>{
          return (
            <Col xs={12}>
              <Checkbox
                checked={filter.checked ? filter.checked.value : false}
                label={filter.label}
                onCheck={(e, val) => {
                  this.constructFilters(filter.bot.mobile, val, filter.bot)
                }}
              />
            </Col>
          )
        })
    }

    if(this.state.departmentList.length) {
      departments = this.state.departmentList.map(department => {
        const checked = _.find(this.state.contactFilter, { name: department.name})
        return (
          <Col xs={12}>
            <Checkbox
              checked={checked ? checked.value : false}
              label={department.name}
              onCheck={(e, val) => {
                this.constructFilters(department.name, val)
              }}
            />
          </Col>
        )
      })
    }

    if(this.state.tagsList.length){
      tags = this.state.tagsList.sort((a, b) => a.value.localeCompare(b.value, undefined, { sensitivity: 'accent' })).map(tag=>{
        const checked = _.find(this.state.contactFilter, { name: tag.value, type:'tag'})
        return (
          <Col xs={12}>
            <Checkbox
              checked={checked ? checked.value : false}
              label={this.titleCase(_.toLower(tag.value))}
              onCheck={(e, val) => {
                this.constructFilters(tag.value, val)
              }}
            />
          </Col>
        )
      })
    }

    return (
      <div className="message-container">
        <Col xs={12} sm={5} className="conversations-wrapper no-padding">
          <div className="conversation-menu">
            <div className="pull-right">
              <span>Conversations</span>
            </div>
            <div className="clearfix" />
          </div>
          <div>
            <div>
              <Card
                expanded={this.state.openFilter}
                onExpandChange={() => {
                  this.setState({ openFilter: !this.state.openFilter })
                }}
                style={{ backgroundColor: '#e0e0e0' }}
              >
                <CardHeader
                  title="Inbox Filters"
                  actAsExpander={true}
                  avatar={
                    <Avatar
                      icon={<FilterList />}
                      size={30}
                      backgroundColor={this.state.openFilter ? '#4CAF50' : grey400}
                    />
                  }
                  style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                />
                <CardText style={{padding:'0px 16px'}} expandable={true}>
                  <Row>
                    <Col xs={12}>
                      <h5>Group Filters:</h5>
                    </Col>
                    <Col xs={12}>
                      <Checkbox
                        checked={this.state.groupFilterCheck.all}
                        label="All Contacts"
                        onCheck={(e, val) => {
                          this.constructFilters(ALL_CONTACTS, val)
                        }}
                      />
                    </Col>
                    <Col xs={12}>
                      <Checkbox
                        checked={this.state.groupFilterCheck.bot}
                        label="All Texting Numbers"
                        onCheck={(e, val) => {
                          this.constructFilters(ALL_NUMBERS, val)
                        }}
                      />
                    </Col>
                    <Col xs={12}>
                      <Checkbox
                        checked={this.state.groupFilterCheck.location}
                        label="All Locations"
                        onCheck={(e, val) => {
                          this.constructFilters(ALL_LOCATIONS, val)
                        }}
                      />
                    </Col>
                  </Row>
                  {!this.state.isInactiveCompany ? <div
                    style={{
                      maxHeight: '200px',
                      overflow: 'hidden auto',
                      border: '1px solid #A8A8A8'
                    }}
                  >
                    {this.state.companyBots.length ? <Row>
                      <Col xs={12}>
                        <h5>Texting Numbers:</h5>
                      </Col>
                      {botFilters}
                    </Row>: ''}
                    {this.state.departmentList.length ? 
                    <Row>
                      <Col xs={12}>
                        <h5>Locations:</h5>
                      </Col>
                      {departments}
                    </Row> : ''}
                    {this.state.tagsList.length ? 
                    <Row>
                      <Col xs={12}>
                        <h5>Tags:</h5>
                      </Col>
                      {tags}
                    </Row> : ''}
                  </div> : ''}
                  <Row style={{ marginTop: '20px' }}>
                    <Col xs={12}>
                      <RaisedButton
                        label="Search"
                        onClick={this.onSearchContacts}
                        primary={true}
                        disabled={this.state.isInactiveCompany}
                      />
                    </Col>
                  </Row>
                </CardText>
              </Card>
            </div>
          </div>
          <div className="conversation-list">
            {!this.state.isInactiveCompany ?
              <Conversations /> :
              <div
                style={{
                  position: 'absolute',
                  width: '100%',
                  marginTop: '20px',
                  textAlign: 'center'
                }}
              >
                <strong>Company is inactive.</strong>
              </div>
            }
          </div>
        </Col>
        <Threads smWidth={7} isInbox={true} {...this.props} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    company: { selectedCompany, selectedCompanyData },
  } = state
  return { selectedCompany, selectedCompanyData }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initRoom(id) {
      return initRoom(id)
    },
    filterConvo(botId, deptName) {
      dispatch(filterConvo(botId, deptName))
    },
    filterConvoList(data) {
      dispatch(filterConvoList(data))
    },
    getAllConvo() {
      dispatch(getAllConvo())
    },
    toggleConvoLoading(status) {
      dispatch(toggleConvoLoading(status))
    },
    resetConvos() {
      dispatch(resetConvos())
    },
    changeConvo(id) {
      dispatch(changeConvo(id))
    },
    setConvoDetails(body) {
      dispatch(setConvoDetails(body))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Inbox)
